export const ALLOCATEDCOUPONS_CONSTANTS = 'ALLOCATEDCOUPONS_CONSTANTS';
export const AVAILABLECOUPONS_CONSTANTS = 'ALLOTEDCOUPONS_CONSTATNTS';
